import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {
  LocalApplicationFeaturesEnum,
  LocalApplicationModel,
} from '../../../../models/api/localApplicationModel';
import {SettingsDevelopersApplicationFeaturesUrl} from '../../../../models/url/settingsUrlModel';
import {SettingsDevelopersDeleteFeatureChannelDialog} from '../../dialog/settingsDevelopersDeleteFeatureChannelDialog';
import {DevelopersHeaderInboxSidePanelEntryPointActionContainer} from './developersHeaderInboxSidePanelEntryPointActionContainer';

/*
 * Props.
 */

interface SettingsDevelopersHeaderFeaturesActionProps {
  url: SettingsDevelopersApplicationFeaturesUrl;
  application?: LocalApplicationModel;
}

/*
 * Component.
 */

export const SettingsDevelopersHeaderFeaturesAction: FC<SettingsDevelopersHeaderFeaturesActionProps> = (
  props,
) => {
  const {application, url} = props;
  const [isShowingChannelDeleteDialog, setIsShowingChannelDeleteDialog] = useState(false);

  if (!application || !url.feature) {
    return null;
  }

  switch (url.feature) {
    case LocalApplicationFeaturesEnum.INBOX_SIDEPANEL:
      return <DevelopersHeaderInboxSidePanelEntryPointActionContainer applicationId={url.applicationId} />;
    case LocalApplicationFeaturesEnum.CHANNEL: {
      if (!application.channelType || !application.channelType.value) {
        return null;
      }
      return (
        <>
          <Button
            variant={ButtonVariantsEnum.SECONDARY_DANGER}
            onClick={() => setIsShowingChannelDeleteDialog(true)}
          >
            <Trans id="settings-developers-delete-channel-action-button">Delete</Trans>
          </Button>
          {isShowingChannelDeleteDialog && (
            <SettingsDevelopersDeleteFeatureChannelDialog
              localApplicationId={application.id}
              channelType={application.channelType.value}
              onRequestClose={() => setIsShowingChannelDeleteDialog(false)}
            />
          )}
        </>
      );
    }
    default:
      return null;
  }
};
